/**
 * פרטי העסק — מקור אמת יחיד לצד הציבורי.
 *
 * ⚠️ שלושתם מודפסים גם בתוך `New Logo.jpeg` עצמו (CLAUDE.md סעיף 11).
 *    שינוי כאן בלי הפקת לוגו מחדש משאיר את הלוגו עם מספר ישן.
 */
export const COMPANY_NAME = 'נועם ייבוא ושיווק';

/**
 * ⭐ הניסוח הקנוני של הישות המשפטית — לשימוש במסמכים המשפטיים
 *    (תנאי שימוש / מדיניות פרטיות / הצהרת נגישות), שבהם הזהות המלאה נדרשת.
 *    אושר ע"י עו"ד (V2, 02.09.2026) ומשמש אחיד בשלושת הדפים.
 */
export const COMPANY_LEGAL_NAME = 'נועם ייבוא ושיווק, עוסק מורשה, ע.מ. 305536112';

/** ⭐ שתי גרסאות השם — ההסכם החתום נושא את השנייה. ראו CLAUDE.md, פתיחה. */
export const COMPANY_NAME_ALTERNATE = 'נועם שיווק והפצה';

export const COMPANY_TAGLINE = 'יבואנית ויצרנית פתרונות למערכות מיזוג אוויר';

/** ⭐ התקבל מטל 20.08.2026 (Feedback1.md סעיף 17.1). */
export const BUSINESS_NUMBER = '305536112';

/**
 * ⭐ נסגר 20.08.2026 (CLAUDE.md סעיף 7). עודכן 02.09.2026 לכתובת הרשומה
 *    המלאה עם מספר דירה ומיקוד, לפי המסמכים המשפטיים המאושרים (V2).
 * ⚠️ פוטר ה-PDF קורא כתובת מטבלת `settings.company_address` בפרודקשן —
 *    יש לעדכן גם שם (phpMyAdmin) כדי שיתאים.
 */
export const COMPANY_ADDRESS = 'שלום דנינו 1/8, נתיבות, 8767208';

export const PHONE_DISPLAY = '050-441-4009';
export const PHONE_E164 = '+972504414009';
export const PHONE_TEL_HREF = `tel:${PHONE_E164}`;
export const PHONE_WHATSAPP_HREF = 'https://wa.me/972504414009';
/** E.164 בלי ה-`+` — הפורמט ש-`buildClickToChatUrl` (`@noam/shared/whatsapp`) מצפה לו. */
export const PHONE_WA = '972504414009';

export const EMAIL = 'office@noam-imd.co.il';
export const EMAIL_HREF = `mailto:${EMAIL}`;

/**
 * מידות מקור של `/brand/logo.png` (TASKS 6.4 — מונע CLS).
 *
 * ⚠️ ⛔ **לא היחס הסופי המוצג** — ה-CSS קובע גובה קבוע (`h-11`/`h-14`) עם
 *    `w-auto`, והדפדפן מחשב את היחס ממידות המקור שכאן כדי לשריין את המקום
 *    לפני שהתמונה נטענת. שינוי בקובץ הלוגו עצמו (למשל הפקה מחדש עם מספר
 *    טלפון אחר, CLAUDE.md סעיף 11) חייב לעדכן גם את שתי המידות האלה.
 */
export const LOGO_WIDTH = 942;
export const LOGO_HEIGHT = 1068;

/**
 * ⭐ תחום העיסוק המלא — PRD 14.2, "לא לצמצם לפי הקטלוג ההתחלתי". מקור אמת
 * יחיד: מוזז לכאן מ-`AboutPage.tsx` (16.08.2026) כדי ש-`HomePage.tsx` יוכל
 * להציג את אותה רשימה בלי לשכפל אותה - שני מקומות עם עובדות זהות, קובץ אחד.
 */
export const FULL_SCOPE_ITEMS: readonly string[] = [
  'תעלות מיזוג',
  'קופסאות ניפוח (פלנומים)',
  'מרכזיות',
  'מתאמים',
  'הסתעפויות',
  'מעברים והפחתות',
  'חלקים מיוחדים בהתאמה אישית',
  'תריסי רונה',
  'שטוצרים לתעלה',
  'גמישים ומתאמים גמישים',
];
